import Vue from 'vue'
import Message from './message.vue'

Message.newInstance = properties => {
    const _props = properties || {}

    const Instance = new Vue({
        render (h) {
            return h(Message, {
                props: _props
            })
        },
        methods: {
            destroy() {
                document.body.removeChild(this.$el)
            }
        }
    })

    const component = Instance.$mount()
    document.body.appendChild(component.$el)
    const message = Instance.$children[0]

    return {
        component: message,
        message (options) {
            message.add(options)
        },
        destroy() {
            message.$parent.destroy()
        }
    }
}

export default Message
